// extracted by mini-css-extract-plugin
module.exports = {"manageOrder":"ManageOrder_manageOrder__2cRZ_","button":"ManageOrder_button__uO1J8"};